import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Headphones, RefreshCw } from "lucide-react";

/**
 * TariffAndRefurbished — Standalone-Sektion mit zwei Karten:
 *   1. Tarif-Beratung (A1 + MTel) — rot
 *   2. Refurbished-Verkauf — emerald
 * Wurde aus PartnerOffers extrahiert, damit sie zwischen GeräteretterPrämie
 * und der KI-Ankaufsstelle platziert werden kann.
 */
export default function TariffAndRefurbished() {
  return (
    <section className="relative py-20 md:py-24 bg-[#0A0A0B] overflow-hidden" data-testid="tariff-refurbished-section">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="grid md:grid-cols-2 gap-5 md:gap-6">

          {/* Neutrale Tarif-Beratung */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="relative overflow-hidden rounded-[28px] border border-white/10 bg-gradient-to-br from-[#16161B] via-[#101015] to-[#0A0A0B] group p-7 md:p-9 flex flex-col"
            data-testid="tariff-consult-card"
          >
            <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-[#FF2D40]/8 blur-[80px] pointer-events-none"></div>
            <div className="relative flex-1 flex flex-col">
              <div className="inline-flex items-center gap-2 self-start px-3 py-1.5 rounded-full bg-[#FF2D40]/10 border border-[#FF2D40]/25">
                <Headphones className="w-3.5 h-3.5 text-[#FF4F5E]" />
                <span className="text-[10px] uppercase tracking-[0.22em] text-[#FF4F5E] font-bold">Neutrale Beratung</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white mt-4 leading-[1.05]">
                Tarif zu teuer?<br/>
                <span className="text-zinc-500">Wir finden den passenden.</span>
              </h3>
              <p className="text-sm md:text-base text-zinc-400 mt-3 leading-relaxed flex-1">
                Als offizieller Partner von <span className="text-white font-medium">A1</span> und{" "}
                <span className="text-white font-medium">MTel</span> nehmen wir uns Zeit für dich
                — wir analysieren dein Nutzungsverhalten und stellen den Tarif zusammen, der
                wirklich zu dir passt. Persönlich, ehrlich und unverbindlich.
              </p>
              <Link
                to="/kontakt"
                data-testid="tariff-consult-cta"
                className="inline-flex items-center gap-1.5 mt-6 px-5 h-11 rounded-full bg-[#DC1928] hover:bg-[#B01829] text-white font-medium btn-lift self-start"
              >
                Beratungstermin anfragen <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

          {/* Refurbished Geräte zum Verkauf */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="relative overflow-hidden rounded-[28px] border border-emerald-500/20 bg-gradient-to-br from-[#0F1A14] via-[#0B1410] to-[#0A0A0B] group p-7 md:p-9 flex flex-col"
            data-testid="refurbished-card"
          >
            <div className="absolute -bottom-16 -left-12 w-56 h-56 rounded-full bg-emerald-500/8 blur-[90px] pointer-events-none"></div>
            <div className="relative flex-1 flex flex-col">
              <div className="inline-flex items-center gap-2 self-start px-3 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/25">
                <RefreshCw className="w-3.5 h-3.5 text-emerald-400" />
                <span className="text-[10px] uppercase tracking-[0.22em] text-emerald-300 font-bold">Refurbished</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white mt-4 leading-[1.05]">
                Geprüfte<br/>
                <span className="bg-gradient-to-r from-emerald-300 via-emerald-400 to-emerald-300 bg-clip-text text-transparent">Refurbished&nbsp;Handys.</span>
              </h3>
              <p className="text-sm md:text-base text-zinc-400 mt-3 leading-relaxed flex-1">
                Wir verkaufen auch professionell aufbereitete Smartphones — getestet, mit neuem Akku,
                bis zu 50% günstiger als Neuware. iPhones &amp; Samsungs in geprüftem Zustand.
                Aktuelle Verfügbarkeit auf Anfrage.
              </p>
              <Link
                to="/refurbished"
                data-testid="refurbished-cta"
                className="inline-flex items-center gap-1.5 mt-6 px-5 h-11 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0A0B] font-semibold btn-lift self-start"
              >
                Modelle ansehen <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
